import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './kyb-reevaluation-started.dialog.html',
  styleUrls: ['./kyb-reevaluation-started.dialog.scss'],
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
})
export class KybReevaluationStartedDialog {
  constructor(private dialogRef: MatDialogRef<KybReevaluationStartedDialog>) {}

  close() {
    this.dialogRef.close();
  }
}
